import { CustomizationInputPropertiesImage } from './CustomizationInputPropertiesImage';

export class Customization {

  static CustomizationTypeImage = 'image';
  static CustomizationTypeText = 'text';
  static CustomizationTypeFile = 'file';

  static getID(customization : Customization) {
    return customization.id;
  }
  static getName(customization : Customization) {
    return customization.name;
  }
  static getDescription(customization : Customization) {
    return customization.description;
  }
  static getInputType(customization : Customization) {
    return customization.inputType;
  }
  static getInputProperties(customization : Customization) {
    return customization.inputProperties;
  }

  public id : string = '';
  public name : string = '';
  public description : string = '';
  public inputType : string = '';
  public inputProperties = new CustomizationInputPropertiesImage();
}
